import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { getActiveExperienceCode, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { createSelector, select, Store } from '@ngrx/store';
import { LoadSlumpProductCatalogAction } from '../../../actions/single-catalogs.actions';
import { filter, map, take } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getOpenPlatformProducts } from '../../../selectors/products.selectors';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

export const getData = createSelector(
  getOpenPlatformProducts,
  getActiveExperienceCode,
  (stateProducts, experienceCode) => {
    return {
      stateProducts,
      experienceCode,
    };
  },
);

@Injectable()
export class LoadSingleCatalogsSlumpProduct implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getData),
        filter((data) => !!value && !!data.stateProducts.length),
        take(1),
        map((data) => data),
      )
      .subscribe((data) => {
        const product = _safe(
          () => data.stateProducts.find((item) => item.productCode.replace(/^0+/, '') === value),
          undefined,
        );
        if (
          product &&
          (data.experienceCode === ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK ||
            data.experienceCode === ORDER_EXPERIENCES.ARKIK_UNIVERSAL_LINK)
        ) {
          const technicalProductCode = _safe(() => product.technicalProducts[0].technicalProductCode);
          this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: technicalProductCode }));
        } else if (product && data.experienceCode === ORDER_EXPERIENCES.COMMAND_UNIVERSAL_LINK) {
          const ProductCode = _safe(() => product.productCode);
          this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: ProductCode }));
        } else {
          formGroup.get(SpecFieldNames.PRODUCT_SELECTION).setValue(null);
          formGroup.get(SpecFieldNames.PRODUCT_SELECTION).updateValueAndValidity();
          this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: null }));
        }
      });
  }
}

@Injectable()
export class LoadSingleCatalogsSlumpProductMxRef implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getData),
        filter((data: any) => !!value && !!data.stateProducts.length),
        take(1),
        map((data) => data),
      )
      .subscribe((data) => {
        const product = _safe(
          () => data.stateProducts.find((item) => item.productCode.replace(/^0+/, '') === value),
          undefined,
        );
        if (product && data.experienceCode === ORDER_EXPERIENCES.RMX_UNIVERSAL_LINK) {
          const technicalProductCode = _safe(() => product.technicalProducts[0].technicalProductCode);
          this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: technicalProductCode }));
        }

        if (product && data.experienceCode === ORDER_EXPERIENCES.COMMAND_UNIVERSAL_LINK) {
          const ProductCode = _safe(() => product.productCode);
          this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: ProductCode }));
        }

        if (!product) {
          this.store.dispatch(new LoadSlumpProductCatalogAction({ productCode: null }));
        }
      });
  }
}
